export enum IconTextListMode {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
}
